// Shared types for LangGraph POST /chat responses (MexaScreen production chat).
export const STEP_LABELS = {
    project_scoping: 'Step 1 · Project Scoping',
    target_biology: 'Step 2 · Target Biology',
    pdb_selection: 'Step 3 · PDB Selection',
    receptor_preparation: 'Step 4 · Receptor Preparation',
    binding_site: 'Step 5 · Binding Site',
    screening: 'Step 5 · Screening',
    peptide_design: 'Step 6 · Peptide Design',
    docking: 'Step 7 · Docking',
};
export const STEP_LABELS_FR = {
    project_scoping: 'Étape 1 · Brief projet',
    target_biology: 'Étape 2 · Biologie cible',
    pdb_selection: 'Étape 3 · Sélection PDB',
    receptor_preparation: 'Étape 4 · Préparation récepteur',
    binding_site: 'Étape 5 · Site de liaison',
    screening: 'Étape 5 · Screening',
    peptide_design: 'Étape 6 · Design peptidique',
    docking: 'Étape 7 · Docking',
};
/** Localized pipeline step label — never mix languages in one string. */
export function stepLabel(step, lang = 'en') {
    var _a;
    const table = lang === 'fr' ? STEP_LABELS_FR : STEP_LABELS;
    return (_a = table[step]) !== null && _a !== void 0 ? _a : step;
}
export const STEP_COLORS = {
    project_scoping: '#0D00FF',
    target_biology: '#1c9b6d',
    pdb_selection: '#f59e0b',
    receptor_preparation: '#d97706',
    binding_site: '#ef4444',
    screening: '#0ea5e9',
    peptide_design: '#8b5cf6',
    docking: '#6366f1',
};
